export const environment = {
  production: true,
  // "Web application" Google OAuth client ID for "Continue with Google" sign-in.
  // googleSignInClientId: '',
  // Service worker OFF. ngsw-worker.js was intercepting POST XHRs, completing its
  // own pass-through fetch (200, correct body) and never handing the response back
  // to the page, so the XHR hung forever — split payment froze the register while
  // the same endpoint returned 200 in 0.5s to curl and worked from the native app.
  // Auto-update is unaffected: PwaUpdateService.checkVersionJson() polls
  // version.json independently and is the documented path for when this is off.
  // main.ts unregisters any worker already installed on a device.
  swEnabled: false, // kill-switch for the service worker / auto-update; flip to false + redeploy to disable
  googleSignInClientId: '628090102143-fpi35pur972oe9vgdhsaurm0lr4s7i0i.apps.googleusercontent.com',
  // ENG-5929: through the microservices load balancer; paths split out to their own services go there,
  // everything else to the same pre-prod backend. Roll back: https://pre-prod-order-api-backend-628090102143.us-east1.run.app
  apiUrl: 'https://api.beta.labrador.ai',
  websocketHost:'wss://backend.order.labrador.ai',
  logRocket: {
    appId: 'mkwptb/labrador-ai',
    enabled: false,
  },
  stripeClientId: 'ca_DIeb3fjLiRc99bQudxKkUo7bWOQXxm4A',
  orderAppUrl: 'https://order.beta.labrador.ai',
  placesAPIKey: 'AIzaSyDRmxxVBcS640504Q28_fP9JJv8iH-Ki3A',
  storeArr: [645, 685],
  leaflogixApiEndpoint: "https://pre-prod-order-api-backend-628090102143.us-east1.run.app",
};
